
import { THEME_MODE_OPTIONS } from '../../constants/theme.constants';

export default {
    name: "ThemeMenu",

    computed: {
        themeMode() {
            return this.$store.state.theme.themeMode;
        },
        arrowIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/arrow-right-dark.svg') :
                require('@/assets/icons/arrow-right-light.svg');
        },
        windowIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/window-dark.svg') :
                require('@/assets/icons/window-light.svg');
        },
        sunIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/sun-dark.svg') :
                require('@/assets/icons/sun-light.svg');
        },
        moonIconPath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/moon-dark.svg') :
                require('@/assets/icons/moon-light.svg');
        },
    },

    created() {
        this.themeModeOptions = THEME_MODE_OPTIONS
    },

    methods: {
        saveThemeMode(value) {
            this.$store.commit('theme/setThemeMode', value);
        },
    },
}
